import React from 'react';
import type { BadgeBackgroundType } from '@axiom/ui';
import { Badge } from '@axiom/ui';
import type { CalendarConversationInviteeType } from '@axiom/validation';
import { InterviewAttendeeResponses } from '@axiom/const';

export const InterviewGridAttendeeResponse = ({
  name,
  data,
}: {
  name?: string;
  data: CalendarConversationInviteeType['attendeeResponse'] | null;
}) => {
  if (!data) return null;

  let background: BadgeBackgroundType;

  switch (data) {
    case InterviewAttendeeResponses.ACCEPTED: {
      background = 'forest green';
      break;
    }
    case InterviewAttendeeResponses.DECLINED: {
      background = 'red';
      break;
    }
    case InterviewAttendeeResponses.TENTATIVE: {
      background = 'gray';
      break;
    }
    default: {
      background = 'light gray';
    }
  }

  return (
    <Badge name={name ?? 'ATTENDEE_RESPONSE_BADGE'} background={background}>
      {data}
    </Badge>
  );
};
